import { practiceSurfaceAccess } from './practice-access.ts';

/**
 * WHO may run the practice's guided round, and whether it is still owed.
 *
 * WHAT the round contains is no longer decided here. The steps are assembled server-side by
 * src/lib/setup-catalogue.ts and arrive on the membership as `setupRound`, for the reason
 * `capabilities` is resolved there: a second definition of "set up" is free to drift from the
 * first, and this file used to be that second definition.
 */

/** The fields the rules below read — structural, so call sites still type-check. */
export interface PracticeSetupSubject {
  readonly setupRound: {
    readonly steps: readonly { readonly required: boolean; readonly done: boolean }[];
    readonly owed: boolean;
  };
  readonly capabilities: readonly string[];
}

/** Server-enforced `practice.govern`. ONE home — the card that OFFERS the round and the
 *  screen that runs it must not disagree. */
export function canRunPracticeSetup(m: { readonly capabilities: readonly string[] }): boolean {
  return practiceSurfaceAccess(m).canGovern;
}

/**
 * Whether the round is still owed to THIS viewer: the server says whether the practice owes
 * it, and the capability says whether this person is the one who would run it.
 */
export function practiceSetupOwed(m: PracticeSetupSubject): boolean {
  return m.setupRound.owed && canRunPracticeSetup(m);
}
